import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
	project: null,
	// The following four fields are deprecated stubs while consumers migrate
	// to RTK hook isLoading/error. Reducer no longer writes them.
	loading: false,
	error: null,
	templateUpdateLoading: false,
	settingsUpdateLoading: false,
};

const projectDetailsSlice = createSlice({
	name: "projectDetails",
	initialState,
	reducers: {
		clearErrors: (state) => {
			state.error = null;
		},
		clearState: () => initialState,
		/** Full replace - used by getProjectById onQueryStarted lifecycle. */
		setProjectDetails: (state, { payload }) => {
			state.project = payload;
			state.loading = false;
			state.error = null;
		},
		/** Partial merge - used by updateProjectSettings lifecycle. */
		mergeProjectDetails: (state, { payload }) => {
			if (state.project && payload) {
				state.project = { ...state.project, ...payload };
			} else if (payload) {
				state.project = payload;
			}
		},
		/** Alias for component cleanup. */
		clearProjectDetails: () => initialState,
	},
});

export const {
	clearErrors,
	clearState,
	setProjectDetails,
	mergeProjectDetails,
	clearProjectDetails,
} = projectDetailsSlice.actions;

export const selectProjectDetails = (state) =>
	state.projectDetails.project || {};

export const selectCurrentProjectId = (state) =>
	state.projectDetails?.project?.id;

export default projectDetailsSlice.reducer;
